@if (certificatesReceived$ | async; as certificatesReceived) {
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title class="title-with-icon"><mat-icon>assignment_turned_in</mat-icon> Diploma's</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-list>
        @for (cert of certificatesReceived; track cert) {
          <mat-list-item>
            <div>{{ cert.certificate.name }} ({{ cert.date | date: "dd-MM-yyyy" }})
              <br>
                @if (
                  cert.examiner && cert.examiner.email !== 'webmaster@orcaroeien.nl'
                  ) {
                  door:
                  <app-member-name [member]="cert.examiner"></app-member-name>
                }
              </div>
              <span fxFlex></span>
              @if (canDelete(cert.certificate.certificateRight) | async) {
                <button mat-icon-button
                  (click)="deleteCertificate(cert.certificate)" [matTooltip]="'Verwijder ' + cert.certificate.name">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </mat-list-item>
          }
        </mat-list>
        @if (certificates$ | async; as certificates) {
          @if (certificates.length > 0) {
            <mat-form-field>
              <mat-label>Geef een Diploma</mat-label>
              <mat-select id="certificate" name="certificate" [formControl]="giveCertControl">
                @for (cert of certificates; track cert) {
                  <mat-option [value]="cert.certificateID"
                    [disabled]="doesContainCert(cert, certificatesReceived)">
                    {{ cert.certificateType }} - {{ cert.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <button mat-raised-button color="primary" (click)="grantCertificate()" [disabled]="!giveCertControl.valid">
              Geef diploma
            </button>
          }
        }
      </mat-card-content>
    </mat-card>
  }